module.exports = __webpack_public_path__ + "img/streak-breakpoint-check.c0e94b7e.svg";